import React, { useState, useEffect } from 'react';
import UserCard from '../UserCard.jsx';
import EditUserForm from '../EditUserForm.jsx';
import { TextField, Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import firebase from '../../firebase/firebaseConfig';
import AccountPayments from '../Account/AccountPayments.jsx';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  title: {
    width: '50%',
  },
  searchFieldDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  searchField: {
    marginBottom: '40px',
  },
}));

const AdminUsers = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState();

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection('class_accounts')
      .onSnapshot((querySnapshot) => {
        setUsers(querySnapshot.docs.map((doc) => doc.data()));
      });

    return () => unsubscribe();
  }, []);

  const handleSearch = async (e) => {
    setLoading(true);
    setSearch(e.target.value);

    //Search firestore for user account that has a field of name that includes the value of what was search

    //Grab all user_accounts documents
    //filter through for those that have name field with the search value

    try {
      const querySnapshot = await firebase
        .firestore()
        .collection('class_accounts')
        .get();
      const allUsers = querySnapshot.docs.map((doc) => doc.data());
      setUsers(
        allUsers.filter((user) =>
          user.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    } catch (error) {
      console.log('error getting documents: ', error);
    }
    setLoading(false);
  };

  return (
    <div>
      <h2 align='center'>All Users</h2>
      <div className={classes.searchFieldDiv}>
        <TextField
          className={classes.searchField}
          align='center'
          label='User Name'
          value={search}
          onChange={handleSearch}
        />
      </div>

      {/* <Divider variant='middle' /> */}
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justify='center' spacing={2}>
              {!loading &&
                users.map((user, i) => (
                  <UserCard
                    key={i}
                    user={user}
                    selectUser={(user) => setUser(user)}
                  />
                ))}
              {loading && <p>Loading...</p>}
            </Grid>
          </Grid>
        </Grid>
      </div>

      {user && <EditUserForm user={user} />}
      {user && <AccountPayments user={user} />}
    </div>
  );
};

export default AdminUsers;
